const updates = [
  {
    date: '07-31',
    title: '香蕉视频本周热播榜更新，《长安三万里》登顶',
    desc: '香蕉视频最新一周播放数据出炉，动画电影《长安三万里》凭借超高口碑登顶热度榜首，多部新片同步上线。',
    tag: '热播榜单',
  },
  {
    date: '07-30',
    title: '红桃视频全新改版上线，观影体验全面升级',
    desc: '红桃视频完成首页改版，优化了推荐算法与播放器性能，加载速度提升40%，画质选项更加丰富。',
    tag: '平台动态',
  },
  {
    date: '07-29',
    title: '91视频经典修复计划启动，百部老片焕新上线',
    desc: '91视频宣布启动经典影片修复计划，首批100部华语经典将以高清修复版重新上线，供影迷免费观看。',
    tag: '内容更新',
  },
  {
    date: '07-28',
    title: '蜜桃视频暑期档专题上线，热门番剧一网打尽',
    desc: '蜜桃视频推出暑期档专题页面，汇集当季最热动漫番剧与综艺节目，提供一站式追番追剧体验。',
    tag: '专题上线',
  },
  {
    date: '07-27',
    title: '99视频高清专区扩容，新增5000+蓝光资源',
    desc: '平台高清专区完成扩容升级，新增5000余部蓝光品质影视资源，涵盖电影、电视剧、纪录片等多个品类。',
    tag: '资源更新',
  },
  {
    date: '07-26',
    title: '多平台搜索功能优化，跨站影片查找更便捷',
    desc: '99视频升级跨平台聚合搜索功能，用户可一键搜索香蕉视频、红桃视频、91视频、蜜桃视频全站资源。',
    tag: '功能升级',
  },
  {
    date: '07-25',
    title: '本周新片速递：《奥本海默》《芭比》同步上线',
    desc: '多部热门新片本周在99视频聚合平台上线，用户无需跳转即可在各视频源之间自由切换观看。',
    tag: '新片速递',
  },
];

const tagColors: Record<string, string> = {
  '热播榜单': 'bg-primary-50 text-primary-700 border-primary-200',
  '平台动态': 'bg-accent-50 text-accent-700 border-accent-200',
  '内容更新': 'bg-secondary-50 text-secondary-700 border-secondary-200',
  '专题上线': 'bg-primary-50 text-primary-700 border-primary-200',
  '资源更新': 'bg-accent-50 text-accent-700 border-accent-200',
  '功能升级': 'bg-secondary-50 text-secondary-700 border-secondary-200',
  '新片速递': 'bg-primary-50 text-primary-700 border-primary-200',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            最新动态
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            关注99视频及各聚合平台的最新资讯，不错过每一次内容更新与功能升级
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {updates.map((item, idx) => (
            <article
              key={idx}
              className="flex gap-4 p-4 md:p-5 rounded-2xl bg-background-100 border border-background-200/60 hover:border-primary-200/60 transition-all duration-200 cursor-pointer group"
            >
              <div className="flex-shrink-0 w-14 h-14 md:w-16 md:h-16 rounded-xl bg-primary-50 flex flex-col items-center justify-center">
                <span className="text-primary-600 font-bold text-base leading-none">{item.date.split('-')[0]}</span>
                <span className="text-primary-500 text-xs">/{item.date.split('-')[1]}</span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium border ${tagColors[item.tag]}`}>
                    {item.tag}
                  </span>
                </div>
                <h3 className="font-semibold text-foreground-950 text-sm md:text-base mb-1 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs md:text-sm leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
              <div className="flex-shrink-0 flex items-center">
                <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors text-lg"></i>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}